import * as React from 'react';
import { clsx } from 'clsx';
import { PropertyValuesScreenReact } from 'common/widgets/property-filter-menu/property-values-screen';
import { SelectTheme } from 'common/components/select/constants';
import { SelectReact } from 'common/components/select';
import { CommitPropertyFilterEvent } from 'common/widgets/property-filter-menu/property-values-screen/types';
import { useTranslation } from 'common/i18n/hooks';
import { FilterValueProps } from '../types';
export function FilterObjectValue(props: FilterValueProps) {
  const {
    t
  } = useTranslation();
  const [, operator, ...labelParts] = props.filter.getLabelParts();
  const label = [operator.label, ...labelParts.map(part => part.label)].join(" ");
  return <SelectReact className={clsx("filter-value-select", {
    'is-placeholder': !props.filter.isValid()
  })} elref='filterValueSelect' open={props.isActive} theme={props.hasNewUI ? SelectTheme.Tertiary : SelectTheme.Select} neverShowCaret selectedOption={props.filter.isValid() ? label : t("query-builder.value-placeholder")} readonly={props.readonly} onMenuChange={ev => props.onSelectMenuChange(ev)} data-sentry-element="SelectReact" data-sentry-component="FilterObjectValue" data-sentry-source-file="object.tsx">
      {props.isActive && <PropertyValuesScreenReact elref='filterValue' slot='body' displayValueOnly eventNames={props.eventNames} propertyFilter={props.filter.getAttributes()} projectId={props.projectId} workspaceId={props.workspaceId} onCommitPropertyFilter={(ev: CommitPropertyFilterEvent) => props.updateEntry(ev.detail.propertyFilter)} />}
    </SelectReact>;
}